import { environment } from "src/environments/environment";

// API End Point
export const API_CALLBACK = environment.apiUrl.slice(0, -3) + '/callback';
export const API_CONFIGS = environment.apiUrl + '/configs';
export const API_CONFIGS_BULK = environment.apiUrl + '/configs/-actions/bulk-update';
export const API_USERGROUP = environment.apiUrl + '/usergroups';
export const API_USER = environment.apiUrl + '/users';
export const API_REFERENCE = environment.apiUrl + '/references';
export const API_LOG_AUDIT = environment.apiUrl + '/audit-logs';
export const API_LOG_SERVICE = environment.apiUrl + '/audit-services';
export const API_AUTH_TOKEN = environment.apiUrl + '/auth-tokens';
export const API_EMPLOYEE = environment.apiUrl + '/employees';
export const API_ASSET = environment.apiUrl + '/assets';
export const API_PARTNER = environment.apiUrl + '/partners';
export const API_CONTACT = environment.apiUrl + '/contacts';
export const API_DOCUMENT = environment.apiUrl + '/documents';
export const API_MARKETING = environment.apiUrl + '/marketing-boards';
export const API_MARKETING_ACTIVITY = environment.apiUrl + '/marketing-activities';
export const API_ITEM = environment.apiUrl + '/items';
export const API_CUSTOMS = environment.apiUrl + '/customs-consultant-boards';
export const API_CUSTOMS_ACTIVITY = environment.apiUrl + '/customs-consultant-activities';
export const API_ARCHIVE_CODE = environment.apiUrl + '/archive-document-codes';
export const API_ARCHIVE_CODE_SUB = environment.apiUrl + '/archive-document-code-subs';
export const API_ARCHIVE_CODE_DETAIL = environment.apiUrl + '/archive-document-code-details';
export const API_ARCHIVE_CONTRACT = environment.apiUrl + '/archive-contracts';
export const API_KITE_TENANT = environment.apiUrl + '/customs-kite-tenants';
export const API_KITE_SOURCE_FILE = environment.apiUrl + '/customs-kite-source-files';
export const API_KITE_TOOL_PIB_HEADER = environment.apiUrl + '/customs-kite-tool-pib-headers';
export const API_KITE_TOOL_PIB_DETAIL = environment.apiUrl + '/customs-kite-tool-pib-details';
export const API_KITE_TOOL_PIB_USED = environment.apiUrl + '/customs-kite-tool-pib-useds';
export const API_KITE_TOOL_MATERIAL = environment.apiUrl + '/customs-kite-tool-raw-materials';
export const API_KITE_TOOL_PRODUCT = environment.apiUrl + '/customs-kite-tool-finish-goods';
export const API_KITE_TOOL_BOM_HEADER = environment.apiUrl + '/customs-kite-tool-boms';
export const API_KITE_TOOL_BOM_DETAIL = environment.apiUrl + '/customs-kite-tool-bom-details';
export const API_KITE_TOOL_PEB_HEADER = environment.apiUrl + '/customs-kite-tool-peb-headers';
export const API_KITE_TOOL_PEB_DETAIL = environment.apiUrl + '/customs-kite-tool-peb-details';
export const API_KITE_TOOL_PEB_REPORTED = environment.apiUrl + '/customs-kite-tool-peb-reporteds';
export const API_KITE_TOOL_KITE_DATA = environment.apiUrl + '/customs-kite-tool-kite-datas';
export const API_KITE_TOOL_PIB_BOM_UNIT_DIFF = environment.apiUrl + '/customs-kite-tool-pib-bom-diffs';
export const API_KITE_TOOL_PIB_USED_VIEW = environment.apiUrl + '/customs-kite-tool-pib-used-views';
export const API_KITE_TOOL_BOM_DETAIL_VIEW = environment.apiUrl + '/customs-kite-tool-bom-dtl-views';
export const API_KITE_TOOL_NIPER = environment.apiUrl + '/customs-kite-tool-niper-items';
export const API_KITE_TOOL_NIPER_VIEW = environment.apiUrl + '/customs-kite-tool-niper-views';
export const API_EMPLOYEE_ATTENDANCE = environment.apiUrl + '/employee-attendances';
export const API_ATTENDANCE_EMPLOYEE = environment.apiUrl + '/attendance-employees';
export const API_ATTENDANCE_CODE = environment.apiUrl + '/attendance-codes';
export const API_LEAVE = environment.apiUrl + '/leaves';
export const API_LEAVE_OFFICE = environment.apiUrl + '/leave-offices';
export const API_LEAVE_EMPLOYEE = environment.apiUrl + '/leave-employees';
export const API_EMPLOYEE_CONTACT = environment.apiUrl + '/employee-contacts';
export const API_EMPLOYEE_DOCUMENT = environment.apiUrl + '/employee-documents';
export const API_GENERAL_PROCUREMENT = environment.apiUrl + '/general-procurements';
export const API_ARCHIVE_LOG = environment.apiUrl + '/archive-document-logs';
export const API_AGENDA_EVENT = environment.apiUrl + '/agenda-events';
export const API_AGENDA_EVENT_VIEW = environment.apiUrl + '/agenda-event-views';
export const API_JIRA_SERVICE = environment.apiUrl + '/jira-service-tiers';
export const API_JIRA_ISSUE = environment.apiUrl + '/jira-issues';
export const API_IT_ASSET = environment.apiUrl + '/it-assets';
export const API_IT_MAINTENANCE_INTERNAL = environment.apiUrl + '/it-maintenance-internals';
export const API_IT_MAINTENANCE_INTERNAL_ACTIVITY = environment.apiUrl + '/it-maintenance-internal-activities';
export const API_IT_MAINTENANCE_EXTERNAL = environment.apiUrl + '/it-maintenance-externals';
export const API_IT_CREDENTIAL = environment.apiUrl + '/it-credentials';
export const MCP_KITETOOL = environment.mcpUrl + '/kitetool';
export const API_GATEWAY_AZURE_VAULT = environment.apiGatewayUrl + '/azure-vault';
export const API_KITE_TOOL_WASTE_HEADER = environment.apiUrl + '/customs-kite-tool-waste-headers';
export const API_KITE_TOOL_WASTE_DETAIL = environment.apiUrl + '/customs-kite-tool-waste-details';
export const API_DASHBOARD = environment.apiUrl + '/dashboard';
export const API_KPI_ACTIVITY = environment.apiUrl + '/kpi-activities';
export const API_ACCURATE_SYNC = environment.apiUrl + '/accurate-syncs';
export const API_ACCURATE_SYNC_VIEW = environment.apiUrl + '/accurate-sync-views';

// Third parties
export const AOL_AUTH_URL = environment.accurateAol;
export const AOL_ACTUAL_REDIRECT_URL = environment.clientRoot + 'aol-callback/actual';
export const AOL_COMMERCIAL_REDIRECT_URL = environment.clientRoot + 'aol-callback/commercial';
export const AOL_SCOPE = 'branch_view bank_transfer_view customer_view customer_save customer_category_view data_classification_view delivery_order_view department_view employee_view exchange_invoice_view expense_accrual_view fixed_asset_view fob_view glaccount_view item_view item_category_view journal_voucher_view other_deposit_view other_payment_view payment_term_view purchase_invoice_view purchase_order_view purchase_payment_view purchase_requisition_view purchase_return_view roll_over_view sales_invoice_view sales_order_view sales_quotation_view sales_quotation_save sales_receipt_view shipment_view tax_view unit_view vendor_view vendor_category_view';
export const AOL_SCOPE_COMMERCIAL = 'branch_view bank_transfer_view bank_transfer_save customer_view customer_save customer_category_view data_classification_view delivery_order_view department_view employee_view exchange_invoice_view expense_accrual_view expense_accrual_save fixed_asset_view fixed_asset_save fob_view glaccount_view glaccount_save item_view item_save item_category_view journal_voucher_view journal_voucher_save other_deposit_view other_deposit_save other_payment_view other_payment_save payment_term_view purchase_invoice_view purchase_invoice_save purchase_order_view purchase_order_save purchase_payment_view purchase_payment_save purchase_requisition_view purchase_return_view purchase_return_save roll_over_view sales_invoice_view sales_invoice_save sales_order_view sales_order_save sales_quotation_view sales_quotation_save sales_receipt_view sales_receipt_save shipment_view tax_view unit_view vendor_view vendor_save vendor_category_view';
export const JIRA_AUTH_URL = environment.jiraUrl;
export const JIRA_SCOPE = '';
export const JIRA_REDIRECT_URL = encodeURI(environment.clientRoot + 'jira-callback');

// Common words
export const OK = 'Sukses';
export const FAIL = 'Gagal';
export const WARN = 'Peringatan';
export const INFO = 'Info';
export const UNCOMPLETE = 'Terdapat isian data yang belum diisi/dipilih, silahkan periksa kembali.';
export const WARNING = {
    EDIT: 'Silahkan pilih data yang ingin diubah.',
    DELETE: 'Silahkan pilih data yang ingin dihapus.',
    RESET: 'Silahkan pilih data yang ingin diatur ulang.',
    EXPORT: 'Silahkan pilih data yang ingin diekspor.',
};
export const RESPONSE = {
    STORE: 'Data berhasil ditambahkan.',
    UPDATE: 'Perubahan data berhasil disimpan.',
    DELETE: 'Data berhasil dihapus.',
    UPLOAD: 'Berkas berhasil diunggah.',
    PROCESS: 'Data berhasil diproses.',
    QUEUE: 'Berkas sedang diproses antrian.',
    ERROR: 'Terjadi masalah saat memproses data.',
    COPY: 'Data berhasil disalin.',
    HTTP_500: 'Terjadi gangguan pada server, hubungi Administrator.',
    HINT_422: 'Terdapat data yang belum diisi/dipilih.',
    HINT_400: 'Payload request tidak sesuai format pada Back-end.',
    HINT_403: 'Anda tidak memiliki hak akses halaman/fungsi ini.',
    HINT_413: 'Payload request terlalu besar.',
    ERROR_403: 'ERROR_UNAUTHORIZED_ACCESS',
    ERROR_413: 'ERROR_REQUEST_TOO_LARGE',
};


// Common default values
export const DEFAULT = {
    OPTION: { code: 'all', 'name': '---' },
    PERIOD: [new Date(), new Date()],
    PERIOD_1: [new Date(new Date().setDate(new Date().getDate() - 1)), new Date()],
    PERIOD_5: [new Date(new Date().setDate(new Date().getDate() - 6)), new Date()],
    PERIOD_LAST_90_DAYS: [new Date(new Date().setDate(new Date().getDate() - 90)), new Date(new Date().setDate(new Date().getDate() + 1))],
    PERIOD_LAST_90__DAYS: [new Date(new Date().setDate(new Date().getDate() - 90)), new Date(new Date().setDate(new Date().getDate() + 30))],
    TODAY: new Date(),
    TODAY_1: new Date(new Date().setDate(new Date().getDate() + 1)),
    TODAY__1: new Date(new Date().setDate(new Date().getDate() - 1)),
    LAST_MONTH: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    LAST_SIX_MONTH: new Date(new Date().setMonth(new Date().getMonth() - 6)),
    LAST_SIX_MONTH_1: new Date(new Date(new Date().setMonth(new Date().getMonth() - 6)).setDate(new Date().getDate() + 1)),
    LAST_YEAR: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    LAST_7_DAYS: new Date(new Date().setDate(new Date().getDate() - 7)),
    LAST_90_DAYS: new Date(new Date().setDate(new Date().getDate() - 90)),
    PERIOD_YEAR: [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 12, 0)],
}
export const PUSHER = {
    KEY: environment.pusherKey,
    CLUSTER: environment.pusherCluster
}
